import { FontAwesomeIcon, Props } from '@fortawesome/react-fontawesome';
import React from 'react';

export type FAIconProps = Props;

// https://fontawesome.com/icons/
// https://github.com/FortAwesome/react-fontawesome#explicit-import
const FAIcon: React.SFC<Props> = (props) => <FontAwesomeIcon {...props} />;
export default FAIcon;
